import { Navigate } from "react-router-dom";
import { Box } from "@chakra-ui/react";
import { useAuthentication } from "../../wrappers/UseAuthentication";

import "./landing.css";

import BackgroundFabric from "./components/BackgroundFabric";
import LandingNavbar from "./components/LandingNavbar";
import Hero from "./components/Hero";
import ProductPreview from "./components/ProductPreview";
import StatsStrip from "./components/StatsStrip";
import BentoGrid from "./components/BentoGrid";
import FinalCta from "./components/FinalCta";
import LandingFooter from "./components/LandingFooter";

const Landing = () => {
  const { isAuthenticated } = useAuthentication();

  if (isAuthenticated) {
    return <Navigate to="/sales" replace />;
  }

  return (
    <Box
      bg="#0a0e1a"
      color="#e6ecf5"
      fontFamily="'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Helvetica, Arial, sans-serif"
      minH="100vh"
      overflowX="hidden"
      sx={{ WebkitFontSmoothing: "antialiased" }}
    >
      <BackgroundFabric />
      <Box as="main" position="relative" zIndex={2}>
        <LandingNavbar />
        <Hero>
          <ProductPreview />
        </Hero>
        <StatsStrip />
        <BentoGrid />
        <FinalCta />
        <LandingFooter />
      </Box>
    </Box>
  );
};

export default Landing;
